export enum ECheckListTypeName {
  AluminiumFormwork = 'AluminiumFormwork',
  Falsework = 'Falsework',
  TimberFormwork = 'TimberFormwork',
}

export enum ELoadingRemovalCertConfirmationActionType {
  srpIssue,
  twcApprove,
  iceApprove,
  requestIceCert,
  withdrawIceCert,
  createRevision,
  createRemovalCert,
  delete,
  removeRemovalCert,
}

export enum ECreateT4FormKeys {
  PROJECT_ID = 'projectId',
  MASTER_SCHEDULE_ID = 'projectMasterScheduleId',
  CERTIFICATE_NO = 'certificateNo',
  LOCATION = 'location',
  ELEMENT_OF_WORKS = 'elementOfWorks',
  CERTIFICATE_NO_TYPE_ID = 'certificateTypeId',
  PERMIT_TO_REMOVE_REQUIRED = 'removalCertRequired',

  EXTENT_OF_OPERATION_AND_CONSTRUCTION_ACTIVITY = 'operationAndConstructionActivity',

  PERMIT_VALID_UNTIL = 'certificateValidDateTime',
  STATUS = 'status',
  IS_REMOVAL_CERT = 'isRemovalCert',
  IS_FINAL_REMOVAL_CERT = 'isFinalRemovalCert',
  OTHER_REFERENCE_DOCUMENTS_FOR_REMOVAL = 'otherReferenceDocumentsForRemoval',
  PERMIT_TO_LOAD_REMARK = 'twcCommentLoad',
  PERMIT_TO_REMOVE_REMARK = 'twcCommentRemoval',
  PERMIT_TO_LOAD_REMARK_ICE = 'iceCommentLoad',
  PERMIT_TO_REMOVE_REMARK_ICE = 'iceCommentRemoval',
  TWC_COMMENT = 'twcComment',
  ICE_COMMENT = 'iceComment',
  RELEASED_FOR_CONSTRUCTION_DRAWINGS = 'project_LoadingRemovalCertDrawing',
  T3_DESIGN_MODIFICATIONS = 'project_LoadingRemovalCertT3',

  LOCATION_PLAN = 'locationPlans',
  CHECKLIST = 'checklists',
  OTHER_REFERENCE_DOCUMENTS = 'otherReferences',

  ICE_CERT = 'iceCert',

  SELECTED_TWCS = 'selectedTwcs',
}
export enum EPermitToLoadRemoveDetailPermitType {
  load,
  remove,
}
